export default "__VITE_ASSET__CEaNuCIT__"